
import { useEffect, } from "react";
import { Helmet } from "react-helmet";


function Team() {

	  useEffect(() => {
		window.scrollTo(0, 0);
	  }, []);
	
  return (
   <>
    <Helmet>
            <title>Meet Our Team | Taskflier </title>
         </Helmet>
            <div class="fancy-hero-five border-bottom " style={{'padding':" 65px 0"}}>
				
				<div class="bg-wrapper">
					<div class="container">
						<div class="row">
							<div class="col-lg-7 m-auto text-center">
                    
                     <h6><span class="upper-title custom-name">Our Team</span></h6>
                     <h3 class="maintitle mt-1">Meet the Team</h3>
                     <p className="mainp">Learn about the individuals behind Taskflier</p>
							</div>
						</div>
					</div>
				</div> 
			</div>

            	<div class="fancy-feature-thirtyFour pt-80 pb-100 bg-gray">
					<div class="container">
						<div class="title-style-two text-center mb-40 md-mb-40">

<h3 class="maintitle "><span>Leadership</span></h3>
							
						</div>

						<div class="row  features justify-content-center">

<div class="col-lg-4 col-6 ">

								<div class="Solutions-box text-center " >
									<img src="/main/images/Team/Director-1.png" alt="Cross-Department Integration" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Mr. Jwala Kumar Pandey</div>
									
									<p className="mainp mt-0 mb-0">Director</p>


								</div>
							</div>

                            <div class="col-lg-4 col-6 text-center ">

								<div class="Solutions-box " >
									<img src="/main/images/Team/Director-2.png" alt="Cross-Department Integration" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Mrs. Rupa Pandey</div>
									
									<p className="mainp mt-0 mb-0">Director</p>


								</div>
							</div>
							<div class="col-lg-4 col-6 ">

								<div class="Solutions-box text-center " >
									<img src="/main/images/male.png" alt="Centralized Project Control" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Mr. Manoj Kumar </div>
									
									<p className="mainp mt-0 mb-0">CEO</p>
								</div>
							</div>
                            <div class="title-style-two text-center mb-20 mt-30">

<h3 class="maintitle "><span>Team</span></h3>
							
						</div>
							<div class="col-lg-3 col-6 ">

								<div class="Solutions-box text-center " >
									<img src="/main/images/Team/General-Manager.png" alt="Dynamic Workflows" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Mr. Akhilesh
									</div>
									<p className="mainp mt-0 mb-0">General Manager</p>
								</div>
							</div>

                            <div class="col-lg-3 col-6 ">
								<div class="Solutions-box text-center " >
									<img src="/main/images/Team/Technical-Head.png" alt="Dynamic Workflows" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Mr. Ashutosh Pandey
									</div>
									<p className="mainp mt-0 mb-0">Technical Head</p>
								</div>
							</div>
                            <div class="col-lg-3 col-6 ">

								<div class="Solutions-box text-center " >
									<img src="/main/images/male.png" alt="Dynamic Workflows" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Mr. Neeraj
									</div>
									<p className="mainp mt-0 mb-0">Senior Developer</p>
								</div>
							</div>
                             <div class="col-lg-3 col-6 ">
								<div class="Solutions-box text-center " >
									<img src="/main/images/Team/Buland-Developer.png" alt="Dynamic Workflows" class="w-100" style={{borderRadius: "50%"}} />
									<div class="pack-name mt-3 text-capitalize">Mr. Bulend
									</div>
									<p className="mainp mt-0 mb-0">Senior Developer</p>
								</div>
							</div>


                             <div class="col-lg-3 col-6 ">

								<div class="Solutions-box text-center " >
									<img src="/main/images/Team/Kundan-Developer.png" alt="Dynamic Workflows" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Mr. Kundan
									</div>
									<p className="mainp mt-0 mb-0">Developer</p>
								</div>

							</div>
                             <div class="col-lg-3 col-6 ">

								<div class="Solutions-box text-center " >
									<img src="/main/images/Team/Rajan-Developer.png" alt="Dynamic Workflows" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Mr. Rajan Chaudhary
									</div>
																		<p className="mainp mt-0 mb-0">Developer</p>
								</div>

							</div>

                            <div class="col-lg-3 col-6 ">

								<div class="Solutions-box text-center " >
									<img src="/main/images/Team/Sr-Designer.png" alt="Dynamic Workflows" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Mr. Jai Chand
									</div>
									
									<p className="mainp mt-0 mb-0">Sr. UI/UX Designer</p>

								</div>

							</div>
                            <div class="col-lg-3 col-6">

								<div class="Solutions-box text-center " >
									<img src="/main/images/Team/Designer.png" alt="Dynamic Workflows" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Mr. Anil
									</div>
									
									<p className="mainp mt-0 mb-0">Sr. UI/UX Designer</p>

								</div>

							</div>

						</div>
					</div>
				</div>

                 <div class="fancy-feature-ten pt-80 pb-40 bg-white" id="feature" hidden>
                            <div class="bg-wrapper2 bglightgreen pt-80 ">
                              <div class="container">
                                
                             <div class="title-style-two text-center mb-40 md-mb-40">

<h3 class="maintitle "><span>Advisory Board</span></h3>
							
						</div>

                     <div class="row  features align-items-center">

<div class="col-lg-4 col-6 ">

								<div class="Solutions-box text-center " >
									<img src="/main/images/male.png" alt="Cross-Department Integration" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Mr. Jwala Kumar Pandey</div>
									
									<p className="mainp mt-0 mb-0">Director</p>


								</div>
							</div>

                            <div class="col-lg-4 col-6 text-center ">

								<div class="Solutions-box " >
									<img src="/main/images/female.png" alt="Cross-Department Integration" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Mrs. Rupa Pandey</div>
									
									<p className="mainp mt-0 mb-0">Director</p>


								</div>
							</div>
							<div class="col-lg-4 col-6 ">

								<div class="Solutions-box text-center " >
									<img src="/main/images/male.png" alt="Centralized Project Control" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Mr. Manoj Kumar </div>
									
									<p className="mainp mt-0 mb-0">CEO</p>


								</div>

							</div>

                            </div>
                     
                               
                              </div>
                              <img src="/images/shape/137.svg" alt="HR Management" class="shapes shape-one"/>
                            </div> 
                          </div>
   </>
  )
}

export default Team
